<template>
  <v-dialog v-model="show" :max-width="dialogWidth" scrollable persistent>
    <v-card elevation="10" class="rounded-xl">
      <v-card-title class="headline primary white--text py-3">
        <v-icon large left dark>mdi-microscope</v-icon>
        Nuevo microorganismo
        <v-spacer></v-spacer>
        <v-btn icon dark @click="closeModal">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>

      <v-card-text class="mt-4 px-6">
        <v-form lazy-validation ref="form">
          <v-container class="py-0">
            <v-row class="pt-2">
              <v-col cols="12" md="6">
                <v-text-field
                  v-model="name"
                  dense
                  clearable
                  outlined
                  label="Nombre común"
                  prepend-inner-icon="mdi-tag"
                  class="rounded-lg"
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="6">
                <v-select
                  v-model="type"
                  :items="microorganismTypes"
                  label="Tipo de microorganismo"
                  outlined
                  dense
                  prepend-inner-icon="mdi-shape"
                  class="rounded-lg"
                  :rules="[(v) => !!v || 'Campo requerido']"
                ></v-select>
              </v-col>

              <v-col cols="12" md="4">
                <v-text-field
                  v-model="genus"
                  dense
                  clearable
                  outlined
                  label="Género"
                  prepend-inner-icon="mdi-alpha-g-circle"
                  class="rounded-lg"
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="4">
                <v-text-field
                  v-model="species"
                  dense
                  clearable
                  outlined
                  label="Especie"
                  prepend-inner-icon="mdi-alpha-s-circle"
                  class="rounded-lg"
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="4">
                <v-text-field
                  v-model="family"
                  dense
                  clearable
                  outlined
                  label="Familia"
                  prepend-inner-icon="mdi-alpha-f-circle"
                  class="rounded-lg"
                ></v-text-field>
              </v-col>
            </v-row>
          </v-container>
        </v-form>
      </v-card-text>

      <v-divider></v-divider>

      <v-card-actions class="grey lighten-4 pa-6">
        <v-row>
          <v-col cols="6">
            <v-btn
              color="error"
              block
              @click="closeModal"
              :disabled="loading"
              outlined
              large
              class="rounded-lg"
            >
              <v-icon left>mdi-cancel</v-icon>
              Cancelar
            </v-btn>
          </v-col>
          <v-col cols="6">
            <v-btn
              color="primary"
              block
              @click="confirmation"
              :loading="loading"
              large
              class="rounded-lg"
              depressed
            >
              <v-icon left>mdi-content-save</v-icon>
              Guardar
            </v-btn>
          </v-col>
        </v-row>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
//vuex
import { mapActions, mapMutations } from "vuex";
//validations
import { requiredValidation } from "@/helpers/validations.js";

export default {
  data: () => ({
    loading: false,
    type: null,
    name: null,
    genus: null,
    species: null,
    family: null,
    microorganismTypes: [
      { text: "Bacteria", value: "bacteria" },
      { text: "Hongo", value: "fungi" },
      { text: "Nematodo", value: "nematode" },
    //   { text: "Virus", value: "virus" },
    //   { text: "Protozoo", value: "protozoa" },
    ],
  }),
  props: {
    value: Boolean,
  },
  computed: {
    dialogWidth() {
      if (this.$vuetify.breakpoint.xs) return "90vw";
      if (this.$vuetify.breakpoint.sm) return "70vw";
      if (this.$vuetify.breakpoint.md) return "60vw";
      return "40vw";
    },
    show: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      },
    },
  },
  methods: {
    ...mapActions("identification", ["addStrainIdentification"]),
    ...mapMutations("alerts", ["SET_ALERT_TYPE"]),
    closeModal() {
      this.show = false;
    },
    validation(name) {
      return requiredValidation(name);
    },
    async confirmation() {
      if (this.$refs.form.validate()) {
        try {
          this.loading = true;

          let payload = {
            moType: this.type,
            name: this.name,
            genus: this.genus,
            species: this.species,
            family: this.family,
          };
          await this.addStrainIdentification(payload);

          this.$refs.form.reset();
          this.SET_ALERT_TYPE({
            visible: true,
            type: "success",
            text: `Microorganismo registrado con éxito`,
            timeout: 5000,
          });
          this.closeModal();
        } catch (error) {
          console.log(error);
          this.SET_ALERT_TYPE({
            visible: true,
            type: "error",
            text: `Algo salió mal. Error: ${error.message}`,
            timeout: 5000,
          });
        } finally {
          this.loading = false;
        }
      }
    },
  },
};
</script>

<style scoped>
.rounded-xl {
  border-radius: 16px !important;
}
.v-card__title {
  border-top-left-radius: 16px !important;
  border-top-right-radius: 16px !important;
}
</style>
